var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKenstar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 47,
    viewBox: "0 0 126 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4889_56768)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0571 3.87955e-05C84.5867 2.3022 84.5542 5.5544 85.6335 7.14911C83.6441 10.9917 82.339 15.5095 79.2907 18.3019C78.8049 16.3849 80.5172 14.1845 80.7327 12.0113C77.1302 12.2963 72.7802 14.819 70.0638 17.4452C68.2301 19.2181 65.5889 22.4703 66.0268 25.166C66.593 28.6557 71.5931 28.9526 72.6588 32.6001C71.9027 34.0506 72.2191 36.8956 71.2167 38.8907C69.2376 42.83 59.5728 47.7787 55.9361 46.8982C53.9586 46.4198 53.052 43.6104 52.7646 41.4643C57.6501 41.0979 61.6118 38.5362 64.5865 35.4587C62.2892 32.7392 58.6953 31.9215 58.531 27.4512C58.1137 16.0286 73.1651 -0.0288018 85.0571 3.87955e-05Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.7305H6.91932V27.1646C8.42292 24.8437 9.64257 22.2413 10.9563 19.7305H18.7412C16.9211 22.7876 15.0275 25.77 13.2622 28.8814C14.8308 32.2829 18.139 35.4825 19.3176 38.3174H11.2437C10.0548 35.7794 8.23818 33.8624 7.2067 31.1683C6.53615 32.9819 7.10919 36.0271 6.91761 38.3174H0V19.7305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1834 19.7305H32.869V24.8777C30.9446 25.066 28.259 24.501 26.8136 25.1644V26.0228C27.5406 27.3037 30.6179 26.2535 32.2926 26.5945V31.455H26.8136V33.1702C28.3548 33.8335 31.1362 33.2686 33.1564 33.4569V38.3174H20.1816V19.7305H20.1834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7529 19.7305H42.6722C44.2853 23.0879 46.1618 26.1823 48.1512 29.1664C47.6979 26.3757 47.9032 22.9301 47.8622 19.7305H54.4941V38.3174H47.5748C46.1653 34.9498 43.8047 32.5255 42.3849 29.1664C42.2309 31.2294 42.4943 35.3468 42.3849 38.3174H35.7529V19.7305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.8115 19.7305H88.2283V26.0211H84.4804V38.3174H77.8485V26.3078C77.0719 25.6496 75.0671 26.206 73.8115 26.0211V19.7305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.203 19.7305C103.165 26.0771 105.572 31.9826 107.546 38.3174H100.338C100.184 37.5166 99.9151 36.8312 99.7612 36.0305H94.8603C94.4327 36.5598 94.3078 37.3894 94.2839 38.3174H86.7881C89.0734 32.1964 91.3605 26.0771 93.42 19.7305H101.205H101.203ZM96.0133 31.74H98.6082C97.9993 30.0571 97.7239 28.0416 97.1662 26.3061C96.86 28.1943 96.1946 29.7263 96.0133 31.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.699 19.7306C116.97 18.6839 128.154 19.9936 124.558 28.5949C124.117 29.6518 123.042 30.4644 121.387 30.8817C122.647 33.6352 124.804 35.4979 126 38.3158H118.504C117.623 36.4242 116.595 34.6802 115.62 32.8819C114.951 34.1255 115.521 36.5956 115.331 38.3158H108.699V19.7289V19.7306ZM115.331 28.3098C117.646 28.6033 118.585 27.5328 118.215 25.1645C117.56 24.6708 116.604 24.474 115.331 24.5928V28.3098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.331 24.5922C116.604 24.4735 117.56 24.6703 118.215 25.164C118.585 27.5323 117.647 28.6028 115.331 28.3093V24.5922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1666 26.3076C97.7243 28.0431 97.9997 30.0569 98.6086 31.7415H96.0137C96.195 29.7295 96.8604 28.1975 97.1666 26.3076Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4889_56768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKenstar);
export default __webpack_public_path__ + "static/media/kenstar.dabe658666d866b1164eef7381f1e95d.svg";
export { ForwardRef as ReactComponent };